<template>
    <card xs-tile sm-tile class="h-full">
        <card-text fill>
			<user-content :text="article.content"/>
        </card-text>
    </card>
</template>

<script setup lang="ts">
const {$auth, $app} = useNuxtApp();
const {t} = useI18n();

const {data: article} = await useApiFetch('/v1/views/finisherpoints', {
	guest: true
});

useMeta({
	title: t('view.finisherpoints.index.title'),
	description: t('view.finisherpoints.index.description'),
	canonical: $app('blog-article', {params: {article: article._key}}, {absolute: true, locale: 'de'})
})

</script>

